export default {"src":"/_next/static/image/public/images/flags/flag_856.3500e2a0bdbc86047d4346a089f261b4.svg","height":16,"width":24};